import { render, staticRenderFns } from "./GameConfigWizard.vue?vue&type=template&id=4fd2d73c&scoped=true"
import script from "./GameConfigWizard.vue?vue&type=script&lang=js"
export * from "./GameConfigWizard.vue?vue&type=script&lang=js"
import style0 from "./GameConfigWizard.vue?vue&type=style&index=0&id=4fd2d73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2d73c",
  null
  
)

export default component.exports